module.exports = __webpack_public_path__ + "img/iata.ed12c9aa.png";